(() => {
  const API_URL = 'https://judge.me/api/v1/widgets/featured_carousel';
  const BODY_MAX = 280;

  const init = () => {
    document.querySelectorAll('[data-judgeme-carousel]:not([data-judgeme-ready])').forEach(populate);
  };

  const populate = async (carousel) => {
    carousel.setAttribute('data-judgeme-ready', '');

    const shop = carousel.dataset.judgemeShop;
    const token = carousel.dataset.judgemeToken;
    const minRating = parseInt(carousel.dataset.judgemeMinRating, 10) || 4;

    const frame = carousel.closest('.review-carousel__frame');
    const slots = Array.from(carousel.querySelectorAll('[data-judgeme-slot]'));
    const starFullTpl = frame?.querySelector('[data-judgeme-star-full]');
    const starEmptyTpl = frame?.querySelector('[data-judgeme-star-empty]');

    if (!shop || !token || !slots.length || !starFullTpl || !starEmptyTpl) {
      hideSection(carousel);
      return;
    }

    let reviews;
    try {
      reviews = await fetchReviews({ shop, token });
    } catch (err) {
      console.warn('[judgeme-reviews] fetch failed:', err);
      hideSection(carousel);
      return;
    }

    const filtered = reviews
      .filter((r) => r.rating >= minRating && r.body.length > 0)
      .sort((a, b) => b.rating - a.rating)
      .slice(0, slots.length);

    if (!filtered.length) {
      hideSection(carousel);
      return;
    }

    slots.forEach((slot, i) => {
      const review = filtered[i];
      if (!review) {
        slot.remove();
        return;
      }
      fillSlot(slot, review, { starFullTpl, starEmptyTpl });
      slot.removeAttribute('hidden');
    });

    carousel.classList.toggle('is-scrollable', carousel.scrollWidth > carousel.clientWidth);
  };

  const fetchReviews = async ({ shop, token }) => {
    const url = new URL(API_URL);
    url.searchParams.set('api_token', token);
    url.searchParams.set('shop_domain', shop);

    const res = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    if (!data || typeof data.featured_carousel !== 'string') {
      throw new Error('unexpected response shape');
    }

    return parseCarouselHtml(data.featured_carousel);
  };

  const parseCarouselHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const items = Array.from(doc.querySelectorAll('.jdgm-carousel-item'));
    return items.map((item) => {
      const ratingLabel = item.querySelector('.jdgm-carousel-item__review-rating')?.getAttribute('aria-label') || '';
      const ratingMatch = ratingLabel.match(/(\d+)/);
      const rating = ratingMatch ? parseInt(ratingMatch[1], 10) : 0;
      const body = (item.querySelector('.jdgm-carousel-item__review-body')?.textContent || '').trim();
      const name = (item.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent || '').trim();
      const product = (item.querySelector('.jdgm-carousel-item__product-title')?.textContent || '').trim();
      return { rating, body, name, product };
    });
  };

  const fillSlot = (slot, review, { starFullTpl, starEmptyTpl }) => {
    const ratingEl = slot.querySelector('[data-rating-container]');
    if (ratingEl) {
      const rating = Math.max(0, Math.min(5, Math.round(review.rating)));
      ratingEl.replaceChildren();
      ratingEl.setAttribute('aria-label', `${rating} out of 5 stars`);
      for (let i = 1; i <= 5; i++) {
        const tpl = i <= rating ? starFullTpl : starEmptyTpl;
        ratingEl.appendChild(tpl.content.cloneNode(true));
      }
    }

    const bodyEl = slot.querySelector('[data-review-body]');
    if (bodyEl) bodyEl.textContent = truncate(review.body, BODY_MAX);

    const nameEl = slot.querySelector('[data-review-name]');
    if (nameEl) {
      // "Anonymous" is Judge.me's placeholder for a withheld name: hide the line rather than print the word.
      const anonymous = /^anonymous$/i.test((review.name || '').trim());
      nameEl.hidden = anonymous;
      nameEl.textContent = anonymous ? '' : formatReviewer(review.name);
    }

    const productEl = slot.querySelector('[data-review-product]');
    if (productEl) productEl.textContent = review.product || '';
  };

  const formatReviewer = (name) => {
    const trimmed = (name || '').trim();
    if (!trimmed) return 'Verified buyer';
    const parts = trimmed.split(/\s+/);
    if (parts.length === 1) return parts[0];
    return `${parts[0]} ${parts[parts.length - 1][0].toUpperCase()}.`;
  };

  const truncate = (text, max) => {
    if (text.length <= max) return text;
    const slice = text.slice(0, max);
    const lastSpace = slice.lastIndexOf(' ');
    return (lastSpace > max - 40 ? slice.slice(0, lastSpace) : slice).trimEnd() + '…';
  };

  const hideSection = (carousel) => {
    const section = carousel.closest('.shopify-section--review-carousel');
    if (section) section.style.display = 'none';
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target || document;
    root.querySelectorAll('[data-judgeme-carousel]:not([data-judgeme-ready])').forEach(populate);
  });
})();
